/*
 * @Description: Vuex入口
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: hai-27
 * @LastEditTime: 2020-02-25 22:51:50
 */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import user from './modules/user'
import shoppingCart from './modules/shoppingCart'
import getters from './getters'
import settings from './modules/settings'
import tagsView from './modules/tagsView'
import app from './modules/app'
import store from './modules/store'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    user,
    app,
    store,
    shoppingCart,
    settings,
    tagsView
  },
  getters,
  plugins: [createPersistedState({ // sessionStorage持久化处理
    storage: window.sessionStorage,
    reducer(cache) {
      return {
        user: cache.user,
        store: cache.store,
        permission: cache.permission,
        dictionary: cache.dictionary
      }
    }
  })]
})

